import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { useSessionMutation } from "../components/Slices/accountsApiSlice";

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState();

  const [session] = useSessionMutation();

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        try {
          const { client_secret: clientSecret } = await session({
            stripeId: connectedAccountId,
          }).unwrap();
          return clientSecret;
        } catch (error) {
          console.error("An error occurred: ", error);
          return null;
        }
      };

      setStripeConnectInstance(
        loadConnectAndInitialize({
          // Was hardcoded to a Stripe tutorial/demo account's test key (pk_test_51R3Vn5R...),
          // unrelated to ours — fetchClientSecret below calls our backend's
          // accountSession.create, which is scoped to OUR platform account,
          // so a mismatched key here breaks this embedded UI outright.
          publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#ffffff",
            },
          },
        })
      );
    }
  }, [connectedAccountId, session]);

  return stripeConnectInstance;
};

export default useStripeConnect;
